import { createAction, handleActions } from 'redux-actions';
import { get } from 'lodash';

const openFileViewerModal = createAction('SCREENS/PROJECT_VIEW/OPEN_FILE_VIEWER_MODAL');
const closeFileViewerModal = createAction('SCREENS/PROJECT_VIEW/CLOSE_FILE_VIEWER_MODAL');

const defaultState = {
  show: false,
  filePath: null,
  fileName: null,
};

const reducer = handleActions(
  {
    [openFileViewerModal]: (state, action) => Object.assign({}, state, {
      show: true,
      filePath: get(action, 'payload.filePath', null),
      fileName: get(action, 'payload.fileName', null),
    }),
    [closeFileViewerModal]: () => Object.assign({}, defaultState),
  },
  defaultState
);

export { openFileViewerModal, closeFileViewerModal, reducer };
